import React, {Component} from 'react';
import { Formik, Form, Field } from 'formik';
import {
    Grid,
    Button,
    Message
} from 'semantic-ui-react';

import FormsInputPassword from '../../inputs/password/forms_inputs_password';
import CommonUtility from '../../../../utils/CommonUtility';

class FormsUpdatePassword extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false
    }
    renderFormSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Password Changed Successfully!</Message.Header>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the change</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        return (
            <Formik
                initialValues={{
                    oldPassword: '',
                    newPassword: '',
                    newPasswordConfirm: ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                //validationSchema={UpdatePasswordSchema}
                validate={(values) => {
                    // Additional Validation (if any)
                    
                    let error = {};

                    if(!values.oldPassword){
                        error.newPasswordConfirm = 'Please enter your current password';
                    }
                    else if (values.newPassword !== values.newPasswordConfirm) {
                        error.newPasswordConfirm = 'New passwords do not match.'
                    }
                    else if(!values.newPassword || !values.newPasswordConfirm){
                        error.newPasswordConfirm = 'Please enter your new password';
                    }
                    else if(values.newPassword.length < 8){
                        error.newPasswordConfirm = 'Too short minimum 8 characters'
                    }
                    else if(values.newPassword.length > 30){
                        error.newPasswordConfirm = 'Too long maximum 30 characters'
                    }
                    else if(!CommonUtility.isValidPasswordFormat(values.newPassword)){
                        error.newPasswordConfirm = 'Password must have 8 digits containing at least 1 uppercase, 1 lowercase, 1 numbers, and 1 special characters. (Combination of those 3 is fine)';
                    }
                    return error;
                }}
                onSubmit={(values, actions) => {
                    console.log(values, actions);
                    this.props.updateUserProfileChangePassword({data: values, accessToken: this.props.user.accessToken}, (result, error) => {
                        console.log('done');
                        if (error) {
                            console.log('done-failed');
                            actions.resetForm();
                            actions.setSubmitting(false);
                            this.setState({error: true, success: false, errorMessage: error.errorMessage});
                        }
                        if (result) {
                            console.log('done-success');
                            actions.resetForm();
                            actions.setSubmitting(false);
                            this.setState({error: false, success: true, errorMessage: null});
                        }
                    });
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form style={{paddingBottom: 20, paddingTop: 20}}>
                        <Grid columns={2}>
                            <Grid.Column width={16}>
                                <Field
                                    name="oldPassword"
                                    label="Current Password"
                                    component={FormsInputPassword}
                                    secondaryLabel=""
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="newPassword"
                                    label="New Password"
                                    component={FormsInputPassword}
                                    secondaryLabel=""
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="newPasswordConfirm"
                                    label="Re-enter New Password"
                                    component={FormsInputPassword}
                                    secondaryLabel=""
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                {this.renderFormSubmissionResult()}
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Button
                                    loading={isSubmitting}
                                    type="submit"
                                    primary
                                    disabled={isSubmitting}
                                    fluid
                                    size="big"
                                >
                                    Change My Password
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

export default FormsUpdatePassword;
